export const environment = {
  production: false,
  apiUrl: "https://devapistudentevents.sjcoescience.org/"
};